// src/models/api/voice.ts
import { postRequest } from './rest'

export type EnableVoiceParams = {
  admin_email: string
  admin_name: string
  admin_password?: string
  admin_phone?: string
  company: string
  subdomain: string
}

/**
 * POST /api/v5/orgs/{id}/enable_voice
 * Enables voice (Zello) for an org.
 *
 * IMPORTANT: once set, these settings are immutable.
 */
export const enableVoiceForOrg = async (orgId: string, params: EnableVoiceParams): Promise<any> => {
  const res = await postRequest({
    endpoint: `api/v5/orgs/${orgId}/enable_voice`,
    data: params,
  })

  // Match the pattern used in licenses.ts (tolerate either { data: ... } or plain object)
  return res?.data?.data ?? res?.data
}
